import { EmailTemplate } from "../../shared/EmailViewTemplate";
import { Toast } from "primereact/toast";
import { Table } from "./Table";
import { useRef } from "react";
import { ILogin } from "../../models/Login";

export const OutLookEmails = () => {
    const toast = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    return (
        <>
            {(_roles.includes(2) || _roles.includes(5)) && <Table toast={toast} />}
            <Toast ref={toast} />
        </>
    );
}